import { RatingCategory } from '@sona/shared-model-common';

import { ORDERED_RATINGS, RATING_MAP } from './ordered-ratings';
import { IRatingBoundary } from './rating-boundary.interface';

/**
 * Retrieves the associated {@link RatingCategory rating category} for a given score.
 *
 * @param percentageScore - The percentage value which is floored.
 * @returns The category name of the found information
 */
export function getRatingCategory(percentageScore: number): RatingCategory.GOOD | RatingCategory.SUFFICIENT | RatingCategory.FAILED {
    if (percentageScore < 0) {
        percentageScore = 0;
    }

    const foundInformation = ORDERED_RATINGS.find(
        (v: IRatingBoundary) => v.lowerBoundary <= percentageScore
    );
    return foundInformation?.category ?? RatingCategory.FAILED;
}

/**
 * Clamps the given value to a range of 0 to 1.
 *
 * @param value - The value to clamp
 */
export function clampRatingValue(value: unknown): number {
    return Math.min(1, Math.max(0, Number(value)));
}

/**
 * Clamps the given value to a range of 0 to 1.
 * If the value is `null` or `undefined`, the result will be `undefined`.
 *
 * @param value - The value to clamp
 */
export function clampRatingValueOptional(value: unknown): number | undefined {
    if (value == null) {
        return undefined;
    }

    return clampRatingValue(value);
}

export function isFailed(score: number | null | undefined): boolean {
    return (
        score != null && score < RATING_MAP[RatingCategory.FAILED].upperBoundary
    );
}

export function isWarningOrWorse(score: number | null | undefined): boolean {
    return (
        score != null &&
        score < RATING_MAP[RatingCategory.SUFFICIENT].upperBoundary
    );
}
